'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { OptimizedImage } from '@/components/images/optimized-image';
export function FundingStatusHeader(t0) {
  const $ = _c(12);
  const {
    artwork,
    title,
    description
  } = t0;
  const t1 = `/assets/onramp/status-${artwork}.png`;
  let t2;
  if ($[0] !== t1) {
    t2 = <OptimizedImage nsfw={false} variant="thumbnail" preview={false} loadReveal="none" rounded="" imageClassName="object-contain" src={t1} alt="" size="size-18" className="shrink-0 bg-transparent" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <h3 className="text-lg font-semibold leading-6">{title}</h3>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== description) {
    t4 = <p className="mt-1.5 text-caption leading-4.5">{description}</p>;
    $[4] = description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div>{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <div className="flex items-center gap-4 pt-2">{t2}{t5}</div>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}